/* ==========================================================================
   hc-shop-by-message — Carousel Controller
   Custom Element + Embla Carousel
   Pattern: mirrors hc-categories-carousel (Embla + dots + arrow nav)
   ========================================================================== */

if (!customElements.get('hc-shop-by-message-carousel')) {
  class HcShopByMessageCarousel extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.dotNodes = [];
      this.prevButtons = [];
      this.nextButtons = [];
    }

    connectedCallback() {
      const viewport = this.querySelector('[data-js="viewport"]');
      const indicator = this.querySelector('[data-js="indicator"]');

      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      this.embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      // --- Arrow navigation (desktop only) ---
      this.prevButtons = [...this.querySelectorAll('[data-js="prev"]')];
      this.nextButtons = [...this.querySelectorAll('[data-js="next"]')];

      this.prevButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.embla.scrollPrev());
      });
      this.nextButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.embla.scrollNext());
      });

      this.embla.on('select', () => this.updateArrows());
      this.embla.on('reinit', () => this.updateArrows());
      this.updateArrows();

      // --- Dot indicators ---
      if (indicator) {
        this.buildDots(indicator);
        this.embla.on('select', () => this.updateDots());
        this.embla.on('reinit', () => {
          this.buildDots(indicator);
          this.updateDots();
        });
      }
    }

    disconnectedCallback() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    }

    /** Enable/disable arrow buttons based on scroll position */
    updateArrows() {
      if (!this.embla) return;
      const canPrev = this.embla.canScrollPrev();
      const canNext = this.embla.canScrollNext();

      this.prevButtons.forEach((btn) => { btn.disabled = !canPrev; });
      this.nextButtons.forEach((btn) => { btn.disabled = !canNext; });
    }

    /** Build dot indicators from Embla snap list */
    buildDots(container) {
      const snaps = this.embla.scrollSnapList();
      container.innerHTML = '';
      this.dotNodes = [];

      snaps.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hc-shop-by-message__indicator-dot';
        dot.setAttribute('aria-label', `Go to group ${i + 1}`);
        dot.addEventListener('click', () => this.embla.scrollTo(i));
        container.appendChild(dot);
        this.dotNodes.push(dot);
      });

      this.updateDots();
    }

    /** Toggle active dot */
    updateDots() {
      if (!this.embla || !this.dotNodes.length) return;
      const selected = this.embla.selectedScrollSnap();
      this.dotNodes.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === selected);
      });
    }
  }

  customElements.define('hc-shop-by-message-carousel', HcShopByMessageCarousel);
}
